import React, { useMemo } from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import { PendingUpload } from '@/redux/ducks/document/upload'
import { CssHelper } from '@/modules/base/view/mixin/helpers_mixin'
import UploadIcon from '@assets/images/icons/upload-v2.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { Document } from '@/modules/document/types'
import { useAppSelector } from '@/redux/store'

interface StyleProps {
  progress,
  color,
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  uploadBadge: {
    display: 'flex',
    '&:hover': {
      background: theme.backgroundColor,
    },
    padding: 4,
    position: 'absolute',
    bottom: 'calc(20px + 20%)',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  progress: ({ color }) => ({
    color,
    margin: CssHelper.px(3, 0),
    padding: '0px 5px',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    '& svg': {
      '& *': {
        fill: color,
      },
    },
  }),
  barWrapper: {
    width: '100%',
    position: 'relative',
    background: theme.lightGrey,
    height: 2,
    marginTop: -2,
  },
  bar: {
    position: 'absolute',
    borderBottom: ({ color }) => `2px solid ${color}`,
    width: ({ progress }: StyleProps) => `${progress}%`,
    // marginTop: -3,
  },
}))

interface UploadBadgeProps {
  file: Document,
}

const UploadBadge = (props: UploadBadgeProps) => {
  const pending = useAppSelector((state) => state.document.upload.pending)

  const { file } = props
  const upload: PendingUpload = pending.find(({ uploadToken }) => uploadToken === file.uploadToken)
  const theme = useTheme<ThemeInterface>()

  const {
    progress,
    maxPartNumber,
    totalChunks,
    error,
    running,
  } = upload ?? {}

  const color = error
    ? theme.error
    : running
      ? theme.primary
      : theme.grey2

  const classes = useStyles({ progress, color })

  if (!file.uploadToken || !upload) return null

  return (
    <div className={classes.uploadBadge}>
      <span className={classes.progress}>
        <SVGIcon
          width={'12px'}
          height={'12px'}
          svg={UploadIcon}
        />
        {progress ? Math.floor(progress) : Math.round(((maxPartNumber ?? 0) / totalChunks) * 100)} %
      </span>
      <span className={classes.barWrapper}>
        <span className={classes.bar}></span>
      </span>
    </div>
  )
}

export default UploadBadge
